export default "__VITE_ASSET__ecb81727__"